module.exports = __webpack_public_path__ + "static/img/routed-recycled-plastic-signs-and-posts.d1452c1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pages/products/routed-recycled-plastic-signs-and-posts.jpg
// module id = 426
// module chunks = 0